import ClientAgentExtender from '../Common/clientAgentExtender'
import Shield from './Shield'

export default class Shields extends ClientAgentExtender {
  static instances = {}

  /**
   * @type {number | null}
   * @private
   */
  _idCustomer = null
  /**
   * @type {Shield[] | null}
   * @private
   */
  _terminationPointsForOrder = null
  /**
   * @type {Shield[] | null}
   * @private
   */
  _mobileTerminationPointsForOrder = null
  /**
   * @type {Shield[] | null}
   * @private
   */
  _activeShields = null

  static getInstance (idCustomer) {
    if (this.instances[idCustomer] === undefined) {
      this.instances[idCustomer] = new this(idCustomer)
    }
    return this.instances[idCustomer]
  }

  constructor (idCustomer) {
    super()
    this._idCustomer = idCustomer
  }

  async loadShields (override = false) {
    if (this._terminationPointsForOrder === null || override) {
      let request = {customerId: this._idCustomer}
      let response = await this.ca.makeRequest('t2Shield/info', request, 'GET')
      let tmpPosibleFixShields = []
      let tmpPosibleMobileShields = []
      let tmpActiveShields = []
      response.terminationPointsForOrder.forEach((item) => {
        tmpPosibleFixShields.push(Shield.createFromResponseItem(item, this._idCustomer))
      })
      response.mobileTerminationPointsForOrder.forEach((item) => {
        tmpPosibleMobileShields.push(Shield.createFromResponseItem(item, this._idCustomer))
      })
      response.activeShields.forEach((item) => {
        tmpActiveShields.push(Shield.createFromResponseItem(item, this._idCustomer))
      })
      this._terminationPointsForOrder = tmpPosibleFixShields
      this._mobileTerminationPointsForOrder = tmpPosibleMobileShields
      this._activeShields = tmpActiveShields
    }
  }

  async reloadMobileTerminationPoints () {
    let request = {customerId: this._idCustomer}
    let response = await this.ca.makeRequest('t2Shield/info', request, 'GET')
    let tmpPosibleMobileShields = []
    response.mobileTerminationPointsForOrder.forEach((item) => {
      tmpPosibleMobileShields.push(Shield.createFromResponseItem(item, this._idCustomer))
    })
    this._mobileTerminationPointsForOrder = tmpPosibleMobileShields
  }

  getPossibleShieldByTerminationPoint (idTerminationPoint) {
    let out = null
    if (this._terminationPointsForOrder !== null) {
      this._terminationPointsForOrder.forEach((tpo) => {
        if (tpo.terminationPointId === idTerminationPoint) {
          out = tpo
        }
      })
    }
    return out
  }

  getFirstMobileShield () {
    let out = null
    if (this._mobileTerminationPointsForOrder !== null && this._mobileTerminationPointsForOrder.length > 0) {
      for (let i = 0; i < this._mobileTerminationPointsForOrder.length; i++) {
        for (let j = 0; j < this._mobileTerminationPointsForOrder[i].possibleServices.length; j++) {
          if (this._mobileTerminationPointsForOrder[i].possibleServices[j].disabledMessage === null) {
            out = this._mobileTerminationPointsForOrder[i]
            break
          }
        }
        if (out !== null) {
          break
        }
      }
    }
    return out
  }

  getPosibleMobileDevicesForTerminationPoint (idTerminationPoint) {
    if (this._mobileTerminationPointsForOrder !== null) {
      return this._mobileTerminationPointsForOrder
    }
    return []
  }

  getActiveShieldByIdTerminationPoint (idTerminationPoint) {
    if (this._activeShields !== null) {
      for (let i = 0; i < this._activeShields.length; i++) {
        if (this._activeShields[i].terminationPointId === idTerminationPoint) {
          return this._activeShields[i]
        }
      }
    }
  }

  get terminationPointsForOrder () {
    return this._terminationPointsForOrder
  }

  set terminationPointsForOrder (value) {
    this._terminationPointsForOrder = value
  }

  get mobileTerminationPointsForOrder () {
    return this._mobileTerminationPointsForOrder
  }

  set mobileTerminationPointsForOrder (value) {
    this._mobileTerminationPointsForOrder = value
  }

  get activeShields () {
    return this._activeShields
  }

  set activeShields (value) {
    this._activeShields = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/T2Shield/Shields.js